export default {
    en: {
        zendesk: 'https://nexters.zendesk.com/hc/en-us/requests/new',
    },
    ru: {
        zendesk: 'https://nexters.zendesk.com/hc/ru/requests/new',
    }
}
